import { Component, OnInit } from "@angular/core";
import { ResetPasswordComponent } from "./resetpassword.component";

import { takeUntil } from "rxjs/operators";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";

import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";

@Component({
  selector: "ngx-resetpassword-list",
  templateUrl: "./resetpassword-list.component.html",
  styleUrls: ["./resetpassword-list.component.scss"],
})
export class ResetPasswordListComponent extends BaseListComponent {
  constructor(private _id: FormContainerModel, private tabsservice: TabularService, public dialogService: SimpleModalService) {
    super();
    this.inputEditorform = ResetPasswordComponent;
  }
  ngOnInit() {
    this.apiName = "Authorization";

    this.label = this.translate("ClientApp.GNR.ResetPassword.ChangePassword");
    this.dialogService
      .open(
        this.inputEditorform,
        {
          apiName: this.apiName,
        },
        {
          autoFocus: true,
          closeOnEscape: false,
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        this.tabsservice.closeById(this._id.metadata.id);
      });
  }
}
